import { useEffect, useRef } from 'react';

/**
 * Re-run `reload` on an interval while `active` is true, then stop.
 *
 * Used to live-update a list while something on it is still "running" (a source
 * syncing, a feed generating) so the status flips to success/error on its own -
 * no manual page refresh. Polling only happens while `active`, so an idle page
 * makes no requests. `reload` should be a SOFT refetch (one that doesn't toggle
 * the page's loading spinner) to avoid flicker.
 *
 * `reload` is kept in a ref so its changing identity per render doesn't restart
 * the interval - the timer resets only when `active` (or the interval) changes.
 */
export default function usePollWhileActive(active, reload, intervalMs = 3500) {
  const ref = useRef(reload);
  ref.current = reload;
  useEffect(() => {
    if (!active) return undefined;
    const t = setInterval(() => ref.current(), intervalMs);
    return () => clearInterval(t);
  }, [active, intervalMs]);
}
